ACC.dkgProcessingValidations = ACC.dkgProcessingValidations || {
    maxCustomLengthValue: null,
    // Validations
    figureCuttingOptionValidation: function() {
        if ($('.miter-form-image:not(.hide) img').length) {
            $('.miter-form-error.help-inline').addClass("hide");
            $('.miter-form-error.help-inline .custom-dimension-miterform-popup').addClass("hide");
            return true; // valid
        } else {
            $('.miter-form-error.help-inline').removeClass("hide");
            $('.miter-form-error.help-inline .custom-dimension-miterform-popup').removeClass("hide");
        }
    },
    fixedCuttingLengthValidation: function() {
        var input = $('.fixed-cutting-length-input');
        var numberValue = input.val();
        if (ACC.common.isInteger(numberValue) && numberValue > 0 && numberValue <= this.maxCustomLengthValue) {
            input.removeClass("dimension-input-border");
            $('.dkg-fixed-cutting-overlay .help-inline').addClass("hide");
            $('.dkg-fixed-cutting-overlay .help-inline .custom-length-error').addClass("hide");
            return true; // valid
        } else {
            input.addClass("dimension-input-border");
            $('.dkg-fixed-cutting-overlay .help-inline').removeClass("hide");
            var errorElement = $('.dkg-fixed-cutting-overlay .help-inline .custom-length-error');
            var newErrorMessage = errorElement.text().replace(/-(.*)/, "- " + this.maxCustomLengthValue);
            errorElement.removeClass("hide").text(newErrorMessage);
        }
    },
    figureCuttingLengthValidation: function() {
        var input = $('.input-miter-length');
        var numberValue = input.val();
        if (ACC.common.isInteger(numberValue) && numberValue > 0 && numberValue <= this.maxCustomLengthValue) {
            input.removeClass("dimension-input-border");
            $('.miter-custom-data .help-inline').addClass("hide");
            $('.miter-custom-data .help-inline .custom-length-error').addClass("hide");
            return true; // valid
        } else {
            input.addClass("dimension-input-border");
            $('.miter-custom-data .help-inline').removeClass("hide");
            var errorElement = $('.miter-custom-data .help-inline .custom-length-error');
            var newErrorMessage = errorElement.text().replace(/-(.*)/, "- " + this.maxCustomLengthValue);
            errorElement.removeClass("hide").text(newErrorMessage);
        }
    },
    figureCuttingAnglesValidation: function() {
        var anglesContainers = $('.miter-angle:not(.hide)');
        var allAnglesValid = true;
        $.each(anglesContainers, function() {
            var input = $(this).find('input')
            var numberValue = input.val();
            if (ACC.common.isInteger(numberValue) && numberValue > 0 && numberValue <= 60) {
                input.removeClass('dimension-input-border');
                $(this).find('.help-inline').addClass('hide');
                $(this).find('.miter-validation-angle-invalid-error').addClass('hide');
            } else {
                allAnglesValid = false;
                input.addClass('dimension-input-border');
                $(this).find('.help-inline').removeClass('hide');
                $(this).find('.miter-validation-angle-invalid-error').removeClass('hide');
            }
        });
        setTimeout($.colorbox.resize,50);
        return allAnglesValid;
    },
    cleanAllValidationErrors: function() {
        $('.dimension-input-border').removeClass('dimension-input-border');
        $('.help-inline').addClass('hide');
        setTimeout($.colorbox.resize,50);
    },
    getMaxCustomLengthValue: function() {
         var productULengthUrl = $('#productVariants').data('productLengthUrl');
         var productData = $('#productVariants').data('productData');
         productData.sawingLength = $('.input-miter-length').val();

         $.ajax({
             async: false,
             type: "POST",
             dataType: 'json',
             contentType: 'application/json',
             url: productULengthUrl + productData.baseProduct,
             data: JSON.stringify(productData),
             error: function (data, status) {
                throw new Error('Could not get max length for sawing. Status: "' + status + '", Response: ' + JSON.stringify(data));
             },
             success: function (length) {
                 ACC.dkgProcessingValidations.maxCustomLengthValue = Number(length);
             }
         });
    },
}
